import '../css/landing.css';
import main from '../assets/landingpages.png';
import { useNavigate } from 'react-router-dom';

export default function Landing() {
    const navigate = useNavigate();
    return(
        <div className="landing">
                <span className="left">
                    <div className="caption1">
                        <hr />
                        <h4>እኛ የመጥምቀ መለኮት ቅዱስ ዮሃንስ ሁለገብ መንፈሳዊ ማህበር ነን</h4>
                    </div>
                    <div className="titles">
                        <div className="caption2">
                            <p><span>በማህበረ ዮሃንስ ፤</span> ለሃይማኖታችን እድገት እንሰራለን እናም ሁሉም በድህነት ውስጥ ያሉ እናቶችን እና ወላጅ አልባ ህፃናትን ለመርዳት እንጥራለን።<span></span> </p>
                        </div>
                        <div className="caption3">
                            <p>እጃችንን በመዘርጋት የህብረተሰቡን ለውጥ በማምጣት እድል የሌላቸውን ህፃናት እና ሌሎች ኋላቀር ማህበረሰቦችን ለመርዳት።</p>
                        </div>
                        <div className="btns">
                            <button onClick={() => window.open("#", "_blank", "noopener noreferrer")} type="button" className="btn btn-outline-info">ተጨማሪ ይወቁ</button>
                            <button type="button" className="btn btn-success" style={{width: "100px"}} onClick={()=>navigate("/ለግሱ")}> ለግስ </button>
                        </div>
                    </div>

                </span>
                <span className="right">
                    <img src={main} alt="Smiling Faces" />
                </span>
            </div>
    );
}